import { MarkerClientT, PoiContainerClientT } from 'bovaljaren-models';
import React, { ReactElement, useContext } from 'react';
import { AppContext } from '../../../../state/app.state';
import { isMobile } from '../../../../utils/app.helper';
import Marker from '../Marker/Marker';

type Props={
    onPoiMouseEnter?: (poi?: PoiContainerClientT) => void;
    onPoiMouseLeave?: (poi?: PoiContainerClientT) => void;
};

const SvgMarkers: React.FC<Props> = ({ onPoiMouseEnter, onPoiMouseLeave }): ReactElement => {
    const { state, presentationState } = useContext(AppContext);

    const onPoiClick = (id: number | null): void => {
        state?.setSelectedPoiId(id);

        if (isMobile() && presentationState?.showObjectView) {
            presentationState?.setShowObjectView(false);
            presentationState?.resetPanzoomTranslate();
        }
        isMobile() && presentationState?.setShowSidebarContent(false);
        isMobile() && presentationState?.setShowPoiInfo(true);
    };

    return (
        <>
            {!presentationState?.showObjectView && state?.currentView?.markers.poiContainers?.map(p => {
                const poi = state?.project?.poiContainers?.find(pC => pC.id === p.id);

                return <Marker
                    onClick={(): void => {
                        setTimeout(() => onPoiClick && p.mappingEntityId && onPoiClick(p.mappingEntityId), 1);
                    }}
                    onMouseEnter={(): void => {
                        p.mappingEntityId && state?.setPreviewObjectId(p.mappingEntityId);

                        if (onPoiMouseEnter) {
                            onPoiMouseEnter(poi);
                        }
                    }}
                    onMouseLeave={(): void => {

                        if (onPoiMouseLeave) {
                            onPoiMouseLeave(poi);
                        }
                    }}
                    marker={p}
                    key={p.id} />;
            })}
        </>
    );
};


export default SvgMarkers;